module.exports = __webpack_public_path__ + "img/mask.cb59154c.svg";